<template>
  <div class="loan">
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
    
      
    </div>
    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>       
        An error occurred! Please Try again later.
      </va-notification>
    </div>
  	<div class="row">
      <div class="flex s12 md9">
      	 <va-card >
           <template #title>
    {{$t('loans.LoansMoreDetails')}}
  </template>
          <template slot="actions">           
	            <va-button icon="fa fa-close"
               @click="EditLoanspage()"
               v-if="showedit"
               >Edit Loan
              </va-button>	           
	        </template>
          <template slot="actions">           
	            <va-button icon="fa fa-close"
               @click="guarantors()"
               v-if="showaddG"
               >Add Guarantors
              </va-button>	           
	        </template>
      	 	<template slot="actions">           
	            <va-button icon="fa fa-close" @click="$router.go(-1)">Cancel</va-button>	           
	        </template>
          
          <va-input
          :label="$t('Loan Type')"
              type="text"
              v-model="this.formdata.loanT"
              :readonly = "true" 
             
        />
        <va-input
          :label="$t('Applied Amount')"
              type="number"
              v-model="this.formdata.appliedamount"
            :readonly = "true" 
             
        />
        <va-input
          :label="$t('Total Guaranteed Amount')"
              type="number"
              v-model="this.formdata.AmountGuarantee" 
              :readonly = "true" 
        />
          <va-data-table
      :fields="mode ? detailedFields : fields"
      :data="filteredData"
      :loading="loading"
      hoverable
    >

      <template slot="icon">
        <va-icon name="fa fa-list" color="secondary" />
      </template>
      <template v-slot:name="props">
        {{ props.rowData.name }}
      </template>
      <template v-slot:phonenumber="props">
        {{ props.rowData.phonenumber  }}

      </template>
      <template v-slot:AmountGuarantee="props">
        {{ props.rowData.AmountGuarantee | Currency  }}
      </template>
      <template v-slot:ApprovalStatus="props">

        <div v-if="props.rowData.ApprovalStatus==='Pending' "> 
       <button   style="background-color: blue; color: whitesmoke; border: none; border-radius: 10px; padding: 10px; min-height: 20px; min-width: 110px;">
        {{ props.rowData.ApprovalStatus}}
         </button> 
         <div v-if="showdel"></div>
        </div>
        <div v-if="props.rowData.ApprovalStatus==='Approved' ">
          
       <button style="background-color: green; color: whitesmoke; border: none; border-radius: 10px; padding: 10px; min-height: 20px; min-width: 110px;">
        {{ props.rowData.ApprovalStatus}}</button>
        
      </div>

        <div v-if="props.rowData.ApprovalStatus==='Rejected'"> 
       <button style="background-color: red; color: whitesmoke; border: none; border-radius: 10px; padding: 10px; min-height: 20px; min-width: 110px;">
        {{ props.rowData.ApprovalStatus}} 
      </button> </div>
      </template>
      <template  v-slot:details="props">
        <button  v-if="props.rowData.ApprovalStatus ==='Pending'" style="background-color: red; color: whitesmoke; border: none; border-radius: 10px; padding: 10px; min-height: 20px; min-width: 110px;" @click="Deleteguaranter(props.rowData.LoanapplicationNo, props.rowData.phonenumber)">
                  {{ $t('Delete') }}
                 
                </button>  
      </template>
    </va-data-table>
    <va-modal
      v-model="showConfirmModal"
      position="top"
      size = "medium"
      :title=" $t('Request Guarantorship')"
      cancelClass="none"      
      :okText=" $t('Add') "  
      :cancelText=" $t('modal.cancel')"      
      noOutsideDismiss
      noEscDismiss
      @ok = "FinalPost"
    >
    <form @submit.prevent="onsubmit">

<va-input
:label="$t('Phone Number')"
type="number"
v-model="formdata.mobilenumber"
:error="!!mobilenumber.length"
:error-messages="mobilenumberErrors"
@input="loaddetais"

/>

<va-input v-if="showName"
:label="$t('name')"
:readonly = "true"           
type="text"
v-model="this.formdata.name"
/>
<va-input
:label="$t('Request Amount')"
type="number"
v-model="formdata.amount"
:error="!!amount.length"
:error-messages="amountErrors"
/>
</form>
    </va-modal>
    <div class="row mt-5">            
                <va-button type="submit" @click="onsubmit"  v-if="showsubmit">
                  {{ $t('forms.controls.submit') }}
                </va-button>                        
            </div>
      	 </va-card>
      </div>
    </div>
  
  </div>
</template>
<script src="https://unpkg.com/vue@2.5.13/dist/vue.js"></script>
<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'

export default {
  components: {
    ...spinners      
  },
  name: 'loan',
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      accdetails: JSON.parse(localStorage.getItem('UserMianFosa')),
      token: JSON.parse(localStorage.getItem('Token')),   
      loan_no : this.$route.params.loan_no,
      loading: false,
      term: null,
      processingError: false,
      payment_method : '',
      finalPost : '',
      showaddG : true,
      showedit: true,
      showsubmit: true,
      
      details:{},
      formdata:{
        phone_no:'',
        loanT:'',
        amount:'',
        LoanapplicationNo:'',
        appliedamount:'',
        AmountGuarantee:'',
        grossSalary:'',
        phonenumber:'',
        Delete:'',
        mobilenumber:'',
        user: '',
        name:'',
       
        ApprovalStatus:'',
        
      },
      mobilenumber:'',
      montlyrepayment:'',
      loanT:'',
      amount:'',
      Delete:'',
      ApprovalStatus:'',
      showConfirmModal : false, 
      showsubmit: true,
      showaddG : true,
      showedit : true,
      details : false,
      showdelete:false,
      name:'',
      phonenumber:'',
        LoanapplicationNo:'',
        appliedamount:'',
        AmountGuarantee:'',
        repaymentperiod:'',
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      }     
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },

fields () {
      return [{
        name: '__slot:icon',
        width: '30px',
        dataClass: 'text-center',
      }, {
        name: '__slot:name',
        title: this.$t('Guarantor Name'),
        width: '30%',
        sortField: 'amount',
      }, 
      {
        name: '__slot:phonenumber',
        title: this.$t('Phone Number'),
        width: '20%',
        sortField: 'amount',
      },
      {
        name: '__slot:AmountGuarantee',
        title: this.$t('Amount Guaranteed'),
        width: '20%',
        sortField: 'amount',
      },
      {
        name: '__slot:ApprovalStatus',
        title: this.$t('ApprovalStatus'),
        width: '20%',
        sortField: 'amount',
      },
      {
        name: '__slot:details',
        title: this.$t(''),
        width: '20%',
        sortField: 'details',
      }]
    },
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.details
      }
      console.log(this.term);
      return this.details.filter(item => {
        return item.description.toLowerCase().startsWith(this.term.toLowerCase()) || item.amount.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
    formReady () {

     },      
  },
  methods : {
    GetProduct(id) {      
      return this.loans.filter(item => item.loanType.toLowerCase() === this.id.toLowerCase());      
    },
    onsubmit (e) {
      e.preventDefault();
      if(this.formdata.AmountGuarantee < this.formdata.appliedamount){
                    
			          this.showToast(`Loan is not yet fully Guaranteed`, {
			            position: 'bottom-right',
			            icon: "fa-check",
			            duration: 2500,
			          })
                
      }else{
             
      console.log(this.formdata.appliedamount);
           const form = {
       user:this.userData.user_id,
       phonenumber: this.userData.mobile_number,
       LoanapplicationNo: this.loan_no,

     };
    

     		this.loading = true
				var self = this

				let config = {
					headers: {
						Authorization: this.userData.user_id+' '+this.token
					}
					}

				axios.post(`${this.$apiUrl}SubmitLoan`, form, config) 
				.then(function (res) {
					self.loading = false					
					const resp = res.data;
					
					if(resp == 'True'){              
			          self.showToast(`Loan Successfuly Submited`, {
			            position: 'bottom-right',
			            icon: "fa-check",
			            duration: 2500,
			          })
                setTimeout( () => window.location.reload(), 2500);
			        } else {
			          self.processingError = true
			        }                 
				})
				.catch(function (error) {
				  console.log(error)
				})
  
      }     
      
    },
    guarantors(){
      this.showConfirmModal = true;
    },
    EditLoanspage(loan_no){
      console.log(this.loan_no);
      this.$router.push({name: 'loan-EditLoan', params: { LoanapplicationNo:this.loan_no}});
    },
    GetAppliedLoanDetails () {
      this.loadSelect = true
      this.loading=true
      const self = this
      const form = {
  user:this.userData.user_id,
  LoanapplicationNo:this.loan_no,
      }
      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}ListLoanGuarantors`, form, config)
      .then(function (res) {
        
          self.loadSelect = false
          self.loading = false
          res = res.data
          console.log(res.ApprovalStatus)
          self.details = res.slice()

      })
      .catch(function (error) {
          console.log(error)
      })
    },
    CheckIfGuarantorshipApp() {
      this.loadSelect = true
      const self = this
      const form = {
  user:this.userData.user_id,
  LoanapplicationNo:this.loan_no,
  phonenumber: this.userData.mobile_number,
      }
      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}CheckGuarantorshipApproval`, form, config)
      .then(function (res) {
        const resp = res.data;
        if(resp == "True"){              

         self.showedit=true
        
			} else if(resp == "False") {

                self.showedit=false
			        } 
        else{
                self.showedit=true
      }
      })
      .catch(function (error) {
          console.log(error)
      })
    },
    CheckIfSubmitted () {
      this.loadSelect = true
      const self = this
      const form = {
  user:this.userData.user_id,
  LoanapplicationNo:this.loan_no,
  phonenumber: this.userData.mobile_number,
      }
      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}CheckIfSubmitted`, form, config)
      .then(function (res) {
        const resp = res.data;
        if(resp == true){              
			         
         self.showsubmit= false
         self.showaddG = false
         self.showedit=false
        
			} else {
                self.showsubmit=true;
                self.showaddG = true;
                self.showedit=true
			        } 
      })
      .catch(function (error) {
          console.log(error)
      })
    },
    Deleteguaranter(LoanapplicationNo, phonenumber) {
      console.log(LoanapplicationNo);
      const form = {
       user:this.userData.user_id,
       phonenumber: phonenumber,
       LoanapplicationNo:LoanapplicationNo,

     };
     console.log(this.formdata.amount)

     		this.loading = true
				var self = this

				let config = {
					headers: {
						Authorization: this.userData.user_id+' '+this.token
					}
					}

				axios.post(`${this.$apiUrl}DeleteGuarantor`, form, config) 
				.then(function (res) {
					self.loading = false					
					const resp = res.data;
					
					if(resp == 'True'){              
			          self.showToast(`Guarantor Deleted succefully`, {
			            position: 'bottom-right',
			            icon: "fa-check",
			            duration: 2500,
			          })
                setTimeout( () => window.location.reload(), 2500);
			        } else {
			          self.processingError = true
			        }                 
				})
				.catch(function (error) {
				  console.log(error)
				})
  
      //this.$router.push({name: 'loan-GuarantorshipRequests', params: { loan_no:LoanapplicationNo }});
},
loaddetais(value){
      this.GetGuarantorDetails()
    this.showName = true
         this.formdata.name =  value.name 
           console.log(this.formdata.name)
  },
 
   GetGuarantorDetails() {
      
      const self = this

    	let config = {
					headers: {
						Authorization: this.userData.user_id+' '+this.token
					}
					}
      const form = {
        user:this.userData.user_id,
        phonenumber: this.formdata.mobilenumber,
      };
      axios.post(`${self.$apiUrl}GetMemberDetails`, form, config)
        .then(function (res) {
          self.loadSelect = false
          self.loading = false
          res = res.data
          self.details = res
          self.formdata.name = res.name
         
          console.log(res)
        })

        .catch(function (error) {
          console.log(error)
        })
       
    },
FinalPost(){
  console.log(this.loan_no)
      this.processingError = false;
      this.mobilenumberErrors = this.formdata.mobilenumber ? [] : ['Guarantor Phone Number is required']
     this.amountErrors=this.formdata.amount ? [] : ['Amount is requested']

    const form = {
       user:this.userData.user_id,
       phonenumber: this.formdata.mobilenumber,
       LoanapplicationNo:this.loan_no,
       amount:this.formdata.amount
     };
     console.log(this.formdata.amount)

     		this.loading = true
				var self = this

				let config = {
					headers: {
						Authorization: this.userData.user_id+' '+this.token
					}
					}
          axios.post(`${this.$apiUrl}CheckGuarantor`, form, config) 
				.then(function (res) {
					self.loading = false					
					const resp = res.data;
					
					if(resp == false){ 
            self.Requestguarant()             
			          
			        } else if(resp == true){
                self.showToast(`You have already Requested guarantorship from this person`, {
			            position: 'bottom-right',
			            icon: "fa-check",
			            duration: 25000,
			          })
                setTimeout( () => window.location.reload(), 2500);
  
			        }  else {
			          self.processingError = true
			        }               
				})
				.catch(function (error) {
				  console.log(error)
				})
				
},
Requestguarant () {
  const form = {
       user:this.userData.user_id,
       phonenumber: this.formdata.mobilenumber,
       LoanapplicationNo:this.loan_no,
       amount:this.formdata.amount
     };
     console.log(this.formdata.amount)

     		this.loading = true
				var self = this

				let config = {
					headers: {
						Authorization: this.userData.user_id+' '+this.token
					}
					}

      axios.post(`${this.$apiUrl}RequestGuarantorship`, form, config) 
				.then(function (res) {
					self.loading = false					
					const resp = res.data;
					
					if(resp == 'True'){              
			          self.showToast(`Guarantorship Request sent succefully`, {
			            position: 'bottom-right',
			            icon: "fa-check",
			            duration: 2500,
			          })
                setTimeout( () => window.location.reload(), 2500);
			        } else {
			          self.processingError = true
			        }                 
				})
				.catch(function (error) {
				  console.log(error)
				})
    },

GetLoanDetails () {
      this.loadSelect = true
      const self = this
      const form = {
        LoanapplicationNo:this.loan_no,
  user:this.userData.user_id

      }

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}IndividualLoanDetails`, form, config)
      .then(function (res) {

          self.loadSelect = false
          self.loading = false
          res = res.data
          self.details = res;
          
          self.formdata.AmountGuarantee= res.AmountGuarantee;
          self.formdata.appliedamount = res.appliedamount;
          self.formdata.loanT = res.loanType;
         
          
      })
      .catch(function (error) {
          console.log(error)
      })
    },
 
  },
  created () { 
    this.GetAppliedLoanDetails();
    
    this.GetLoanDetails();
   this.CheckIfSubmitted();
  this.CheckIfGuarantorshipApp();
  }
}
</script>